import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

function TableMarginHeader({ className, onFilter, sortBy, type }) {
  const { t: translate } = useTranslation()
  const nameValue = type === 'group' ? REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME : REVENUE_SORT_COLUMNS.STORE_NAME

  return (
    <div className={classNames('table-margin-header', className)}>
      <div className={classNames('row-wrapper flex-row', sortBy.order)}>
        <Box
          className={classNames('cell-title flex-row cursor-pointer', {
            'is-active': sortBy.value === nameValue,
          })}
          data-value={nameValue}
          onClick={onFilter}
        >
          <Box display="inline" className="category mobile-only" data-value={nameValue} onClick={onFilter} />

          <Box data-value={nameValue} onClick={onFilter}>
            {translate('revenue.store')}
          </Box>
        </Box>

        <Box
          className={classNames('tablet-portrait-up-only', 'cell-category cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CLUSTER,
          })}
          data-value={REVENUE_SORT_COLUMNS.CLUSTER}
          onClick={onFilter}
        >
          <Box display="inline" className="category" data-value={REVENUE_SORT_COLUMNS.CLUSTER} onClick={onFilter}>
            {translate('revenue.table.category')}
          </Box>
        </Box>

        <Box
          className={classNames('cell-value cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN,
          })}
          data-value={REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN}
          onClick={onFilter}
        >
          <Box display="inline" data-value={REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN} onClick={onFilter}>
            {translate('revenue.revenue')}
          </Box>
        </Box>

        <Box
          className={classNames('cell cell-margin cursor-pointer', { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.MARGIN })}
          data-value={REVENUE_SORT_COLUMNS.MARGIN}
          onClick={onFilter}
        >
          {translate('tableMargin.margin')}
        </Box>

        <Box
          className={classNames('cell-margin-value cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.MARGIN_VALUE,
          })}
          data-value={REVENUE_SORT_COLUMNS.MARGIN_VALUE}
          onClick={onFilter}
        >
          {translate('tableMargin.grossProfit')}
        </Box>
      </div>
    </div>
  )
}

TableMarginHeader.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  sortBy: PropTypes.object,
  type: PropTypes.string,
}

export default TableMarginHeader
